(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cellsius-info-panel"] && !Shopify.designMode) return;
  try {
    // Cellsius — volet info : la vignette du justificatif ouvre l'image en grand ; un clic n'importe où la referme.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cellsius-doc]');
    if (trigger) {
      event.preventDefault();
      trigger.parentElement.querySelector('[data-cellsius-dialog]')?.showModal();
      return;
    }
    const dialog = event.target.closest('[data-cellsius-dialog]');
    if (dialog) dialog.close();
  });
  } catch(e) { console.error(e); }
})();

})();
